<!-- <app-modal #modalRoot [maximizable]="false" class="modal-demo" [inViewport]="false"> -->
<div class="dialog">
    <div class="dialog-title d-flex justify-content-between">
        <div class="d-flex align-items-center">
            <mat-icon>drag_indicator</mat-icon>
            <h6 class="mb-0">CAD Viwer
            </h6>
        </div>
        <img src="assets/svg/Multiply.svg" alt="close" (click)="closeDialog()">
    </div>
    <div class="content pt-0 px-0">
        <div class="loader screen loading-overlay" *ngIf="loading">
            <img src="assets/svg/preloader.svg" alt="Loading">
        </div>
        <iframe *ngIf="safeUrl" #iframeRef height="100%" width="100%" frameborder="0" [src]="safeUrl"
            (load)="onIframeLoad(iframeRef)"></iframe>
    </div>
    <div class="footer p-2">
        <div class="d-flex justify-content-end">
            <button class="btn btn-secondary mr-3 fw-semibold" (click)="closeDialog()">
                Cancel
            </button>
        </div>
    </div>
</div>